module.exports = __webpack_public_path__ + "img/p_sz_15.180246bb.svg";